import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const JobsLayout = lazyRouteComponent(() => import("@modules/jobs/pages/JobsLayout"), "JobsLayout");
const JobsPage = lazyRouteComponent(() => import("@modules/jobs/pages/JobsPage"), "JobsPage");
const JobDetailPage = lazyRouteComponent(() => import("@modules/jobs/pages/JobDetailPage"), "JobDetailPage");

export function getRoutes(parentRoute) {
  const jobsRoute = createRoute({
    getParentRoute: () => parentRoute,
    path: "/jobs",
    component: JobsLayout,
  });

  const jobsIndexRoute = createRoute({
    getParentRoute: () => jobsRoute,
    path: "/",
    component: JobsPage,
    validateSearch: (search) => ({
      scanner: search.scanner === "open" ? "open" : undefined,
    }),
  });

  const jobDetailRoute = createRoute({
    getParentRoute: () => jobsRoute,
    path: "/$jobId",
    component: JobDetailPage,
  });

  return [jobsRoute.addChildren([jobsIndexRoute, jobDetailRoute])];
}
